import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Products from './Components/Products';
import './App.scss';

function App() {
  return (
    <main className="App">
      <BrowserRouter>
        <Switch>
          <Route path="/products/:category" component={Products} />
        </Switch>
      </BrowserRouter>
    </main>
  );
}

export default App;
